// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'es6-promise/auto'
import 'babel-polyfill'

import Vue from 'vue'

import axios from 'axios/dist/axios'
Vue.prototype.$ajax = axios

import lodash from 'lodash'
Vue.use(lodash)
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false
})

import Scrollspy from '@/controllers/ScrollSpy'
Vue.use(Scrollspy)

import InfiniteScroll from 'vue-infinite-scroll'
Vue.use(InfiniteScroll)

import VmBackTop from 'vue-multiple-back-top'
Vue.component(VmBackTop.name, VmBackTop)

import 'masonry-layout/masonry'
import VueMasonryPlugin from '@/controllers/Masonry'
Vue.use(VueMasonryPlugin)

import VueImg from 'v-img'
Vue.use(VueImg)

// Buefy Components UI
import Buefy from 'buefy'
Vue.use(Buefy)
import 'buefy/lib/buefy.css'

import AOS from 'aos'
Vue.use(AOS)
import 'aos/dist/aos.css'

// Material Design Icons
import 'material-design-icons/iconfont/material-icons.css'

// load Bulma, override Bulma
// override font-awesome & common styles UI
import '@/styles/app.scss'

// Carousel
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import App from './App'
import store from './controllers/Store'
import router from './router'

// scroll to top for each route change
router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0)
  next()
})

// FB
import FBControl from './controllers/FBControl'
Vue.use(FBControl, {
  appId: '782732588553167',
  version: 'v2.9'
})

// GA
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-3206163-1',
  router
})

// Disqus
import VueDisqus from 'vue-disqus/VueDisqus.vue'

// Modules
import FormError from '@/components/FormError'
import FormInput from '@/components/FormInput'
import SideBar from '@/components/SideBar'
import SectionComment from '@/components/SectionComment'

Vue.component('form-error', FormError)
Vue.component('form-input', FormInput)
Vue.component('side-bar', SideBar)
Vue.component('vue-disqus', VueDisqus)
Vue.component('section-comment', SectionComment)

import moment from 'moment'
Vue.filter('datetime', function (value, format) {
  format = format && format.slice(1, format.length - 1)
  if (!value) {
    return '0'
  }
  console.log(value)
  // return moment(new Date(value)).format(format || 'HH:mm - YYYY-MM-DD')
  return moment(new Date(value)).format(format || 'h:mm A - D MMM YYYY')
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  created () {
    AOS.init({
      duration: 1600
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js